@if (breadcrumbs$ | async; as breadcrumbs) {
    <aimo-breadcrumb
        [hideTitle]="true"
        [showBackLink]="false"
        [addFrontPageLink]="false"
        [normalBreadCrumbs]="breadcrumbs">
    </aimo-breadcrumb>
}

<cx-page-slot position="TopContent"></cx-page-slot>

<cx-page-slot position="PageDescription"></cx-page-slot>

<div class="aimo-tab-wrapper-container">
    <div class="aimo-tab-wrapper fade-white">
        <div class="aimo-tab-border">
            <div class="tab-items">
                <div class="tab-item cursor-pointer active">
                    {{ 'aimo.reports.purchaseReport' | cxTranslate }}
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row cx-search-criteria noPrint" [formGroup]="searchForm">
    <div class="col-12 col-md-6 col-lg-4 order-lg-1">
        <aimo-cx-input
            (afterChange)="fetchReports()"
            [placeholder]="'aimo.reports.searchTitle'"
            [parentForm]="searchForm"
            [nameForm]="'searchTerm'"
            [inputIcon]="'icon-magnifying-glass icon-petrol-blue'">
        </aimo-cx-input>
    </div>
    <div class="col-12 col-md-6 col-lg-4 order-lg-3 range-dates pt-4 pt-md-0">
        <aimo-datepicker-input
            class="date-from"
            [idName]="'delivery_date_from'"
            (afterChange)="fetchReports()"
            [placeholder]="'aimo.orderhistory.dateFrom' | cxTranslate"
            [parentForm]="searchForm"
            [customDayTemplate]="customDay"
            [nameForm]="'from'"></aimo-datepicker-input>
        <span class="date-divider"> - </span>
        <aimo-datepicker-input
            class="date-to"
            [idName]="'delivery_date_to'"
            (afterChange)="fetchReports()"
            [placeholder]="'aimo.orderhistory.dateTo' | cxTranslate"
            [parentForm]="searchForm"
            [customDayTemplate]="customDay"
            [nameForm]="'to'"></aimo-datepicker-input>
    </div>
    <div class="col-12 col-lg-4 order-lg-2">
        <div class="cart-functions float-lg-right h-100">
            <button [id]="'to_excel'" class="btn-link order-5 d-md-inline-block" (click)="exportCartToExcel()">
                <i class="aimo-icon icon-file-arrow-down icon-inline icon-sm"></i>
                <span>{{ 'aimo.cart.export.excel' | cxTranslate }}</span>
            </button>

            <button [id]="'print'" class="btn-link order-6 d-md-inline-block" (click)="print()">
                <i class="aimo-icon icon-printer icon-inline icon-sm"></i>
                <span>{{ 'aimo.cart.print' | cxTranslate }}</span>
            </button>
        </div>
    </div>
</div>

<ng-template
    #customDay
    let-date
    let-currentMonth="currentMonth"
    let-today="today"
    let-selected="selected"
    let-disabled="disabled"
    let-focused="focused">
    <button
        class="calendar-cell calendar-day link"
        [ngClass]="{ focused: focused, selected: selected, disabled: disabled }">
        {{ date.day }}
    </button>
</ng-template>

@if (cart$ | async; as cart) {
    <div class="aimo-order-templates-table">
        <div class="sub-header sub-header-line col-12 row bg-petrol-light p-2 text-bold no-gutters d-none d-lg-flex">
            <div class="col-12 order-1 col-lg-8">
                {{ 'aimo.cart.item.product' | cxTranslate }}
            </div>
            <div class="col-6 order-2 col-lg-2">
                {{ 'aimo.cart.item.quantity' | cxTranslate }}
            </div>
            <div class="col-6 order-3 col-lg-2">
                {{ 'aimo.cart.item.total' | cxTranslate }}
            </div>
        </div>
        @if (!cart.categoryGroupedEntries) {
            <ng-container
                *ngTemplateOutlet="
                    notification;
                    context: { level: 'WARNING', textKey: 'aimo.reports.tooManyResults', excel: true }
                "></ng-container>
        }
        @if (cart.categoryGroupedEntries?.length === 0) {
            <ng-container
                *ngTemplateOutlet="
                    notification;
                    context: { level: 'MESSAGE', textKey: 'aimo.reports.noResults' }
                "></ng-container>
        }
        @for (categoryGroupedEntry of cart.categoryGroupedEntries; track categoryGroupedEntry; let idx = $index) {
            @if (categoryGroupedEntry.title !== null) {
                <div class="col-12 sub-header sub-header-line bg-light-grey p-2 text-bold">
                    {{ categoryGroupedEntry.title !== '' ? categoryGroupedEntry.title : '&nbsp;' }}
                </div>
            }
            @for (entry of categoryGroupedEntry.entries; track entry; let idx = $index) {
                <div
                    class="row no-gutters cart-item reports-item align-center product_code_{{ entry.product.code }}"
                    id="cart_item_{{ entry.entryNumber }}">
                    <div class="col-10 order-1 col-lg-8 pb-2 pb-lg-0" id="product_{{ entry.product.code }}">
                        <div class="row no-gutters">
                            <div class="col-12 align-center">
                                @if (entry.product.purchasable) {
                                    <a
                                        class="cx-product-image-container mr-1 cursor-pointer"
                                        role="button"
                                        [id]="'product_image_' + idx"
                                        (click)="openProductModal(entry.product.code, 'product_image_' + idx)"
                                        tabindex="0">
                                        <cx-media
                                            class="cx-product-image"
                                            [container]="entry.product?.images?.PRIMARY"
                                            format="cartIcon"></cx-media>
                                    </a>
                                }
                                @if (!entry.product.purchasable) {
                                    <div class="product-name-wrapper-wide-mobile">
                                        <div>{{ entry.product.name }}</div>
                                        <div class="product-code">
                                            <span>{{ entry.product.code }} {{ entry.product.lotSizeInfo }}</span>
                                        </div>
                                    </div>
                                }
                                @if (entry.product.purchasable) {
                                    <div class="product-name-wrapper-wide-mobile">
                                        <button
                                            [id]="'product_name_' + idx"
                                            class="btn-link text-left text-bold"
                                            [attr.aria-label]="
                                                'aimo.product.openModal.arialLabel'
                                                    | cxTranslate: { productName: entry.product.name }
                                            "
                                            (click)="openProductModal(entry.product.code, 'product_name_' + idx)"
                                            tabindex="0">
                                            {{ entry.product.name }}
                                        </button>
                                        <div class="product-code">
                                            <span>{{ entry.product.code }} {{ entry.product.lotSizeInfo }}</span>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-2 order-2 col-lg-2 d-none d-md-flex">
                        <span>{{ entry.deliveredQuantity }} {{ entry.unit.name }}</span>
                    </div>
                    <div class="col-2 order-2 col-lg-2 text-right align-text-top d-block d-md-none">
                        <span>{{ entry.deliveredQuantity }} {{ entry.unit.name }}</span>
                    </div>
                    <div class="col-12 order-3 col-lg-2 text-right text-lg-left">
                        <div>
                            <span class="text-bold d-inline-block mr-1">{{
                                entry.deliveredTotalPrice?.formattedValue
                            }}</span>
                            <span class="d-inline-block">{{ 'aimo.cart.item.notax' | cxTranslate }}</span>
                        </div>
                        <div class="text-lowercase">
                            <span class="d-inline-block mr-1">{{
                                entry.deliveredTotalPriceWithTax?.formattedValue
                            }}</span>
                            <span class="d-inline-block">
                                ({{ 'aimo.cart.totals.vat' | cxTranslate: { tax: entry.tax?.rate } }})
                            </span>
                        </div>
                    </div>
                </div>
            }
        }
    </div>
}

<cx-page-slot position="BottomContent"></cx-page-slot>

<ng-template #notification let-level="level" let-textKey="textKey" let-excel="excel">
    @if (!isMessageHidden(textKey)) {
        <div class="notification" [ngClass]="level === 'INFO' ? 'notification-MESSAGE' : 'notification-' + level">
            <div class="left-side">
                <i class="aimo-icon icon-inline icon-{{ level }} mr-2"></i>
            </div>
            <div class="d-inline text-sm middle">
                <span [innerHTML]="textKey | cxTranslate"></span>
                @if (excel) {
                    <button class="btn-link text-underline text-left-space" (click)="exportCartToExcel()">
                        {{ 'aimo.cart.export.excel' | cxTranslate }}
                    </button>
                }
            </div>
            <div class="right-side">
                <button class="btn-link" (click)="hideMessage(textKey)">
                    <i class="aimo-icon icon-petrol-blue icon-inline icon-x float-right"></i>
                </button>
            </div>
        </div>
    }
</ng-template>
